import * as React from 'react';
import { Provider } from 'react-redux';
import store from '@state/store';
import ConnectedProductCount from '../Connectors/ConnectedProductCount';
import type { IProductCount } from '../Components/ProductCount/ProductCount';

export const ProvideProductCount = (props: IProductCount) => {
  return (
    <Provider store={store}>
      <ConnectedProductCount {...props } />
    </Provider>
  );
};
